import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const FreedomToSpeakUp = () => (
  <Page
    title="Freedom to Speak Up"
    intro="Freedom to Speak Up lets any member of staff raise a concern - about patient safety, culture, or anything else - anonymously by default, through a route that is deliberately separate from incident reporting."
  >
    <Section title="Raising a concern">
      <Bullets>
        <Bullet>
          Open <DocLink url="/speak-up" text="Speak Up" /> to raise a concern.
          Choose a category - Patient safety, Bullying or harassment,
          Discrimination, Working conditions or wellbeing, Fraud, theft or
          misconduct, Health and safety, or Other - and describe the concern,
          optionally with when and where it happened.
        </Bullet>
        <Bullet>
          Concerns are <strong>anonymous unless you choose otherwise</strong>.
          An anonymous concern records nothing about who raised it - no name,
          no account, no audit entry. If you opt to be identified, your name
          is attached and you can say how you would like to be contacted.
        </Bullet>
        <Bullet>
          Each concern is given a reference code when it is submitted, so you
          can quote it if you follow up later.
        </Bullet>
      </Bullets>
      <Info title="Not a replacement for incident reporting">
        A patient safety event that has already happened should still be
        reported as an incident - see{' '}
        <DocLink
          docsPage
          url="/clinical-governance/incidents-and-safety-alerts"
          text="Incidents and Safety Alerts"
        />
        . Speak Up is for concerns, including ones about how incidents are
        being handled.
      </Info>
    </Section>

    <Section title="Reviewing concerns">
      <Bullets>
        <Bullet>
          The Governance team reviews concerns from{' '}
          <DocLink url="/speak-up-concerns" text="Speak Up Concerns" />. Each
          concern moves through <strong>New</strong>,{' '}
          <strong>Under Review</strong>, and <strong>Closed</strong>, with an
          assignable reviewer and a notes trail.
        </Bullet>
        <Bullet>
          The team dashboard shows a <strong>Speak up concerns</strong> card
          so new concerns are seen without checking the page.
        </Bullet>
      </Bullets>
      <Screenshot url="governance/speak-up-concerns.png">
        The Speak Up Concerns review list with each concern's reference,
        category, status, and reviewer.
      </Screenshot>
      <Info title="Who can do this?">
        Any signed-in user can raise a concern. Reviewing concerns requires
        the Governance team (site administrators always have access).
      </Info>
    </Section>

    <Section title="Switching Speak Up off">
      <p>
        Freedom to Speak Up is on by default. An organisation that runs its
        speaking-up route elsewhere can switch it off from{' '}
        <DocLink
          url="/site-configuration"
          text="Site Config > Governance > Speak Up"
        />
        - the Speak Up page and sidebar entry are then hidden and new concerns
        cannot be submitted.
      </p>
    </Section>
  </Page>
)

export default FreedomToSpeakUp
